module.exports = __webpack_public_path__ + "static/img/Customised_Clothing_Headers-06.f39feec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/2024/Customised_Clothing_Headers-06.png
// module id = Gfob
// module chunks = 1